module.exports = __webpack_public_path__ + "img/clrz.816fb656.png";